'use client';
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '@/context/AuthContext';
import getToken from '@/hook/getToken';
import { Logout } from '@/components/auth/Logout';
import BASE_URL from '@/components/constants';
import Link from 'next/link';
import { FaUserCircle } from 'react-icons/fa';
import { toast } from 'react-hot-toast';

const SignButton = () => {
  const [userName, setUserName] = useState('');
  const { isSignInOpen, setIsSignInOpen } = useAuth();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null); // ⬅️ Ref for outside click

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = getToken();
        if (!accessToken) return;

        const response = await fetch(`${BASE_URL}/v1/auth/b2c/me`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setUserName(data.userDetails?.name || 'User');
        } else {
          localStorage.removeItem('access_token');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [isSignInOpen]);

  // ⬅️ Close popup on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isPopupOpen]);

  return (
    <>
      {userName ? (
        <div className='relative' ref={popupRef}>
          <div onClick={() => setIsPopupOpen((prev) => !prev)} className='cursor-pointer'>
            <FaUserCircle className='mt-1 text-2xl' />
          </div>

          <div
            className={`absolute right-0 top-8 z-50 w-40 transform rounded border bg-white p-2 shadow-lg transition-all duration-200 ease-out ${
              isPopupOpen
                ? 'translate-y-0 scale-100 opacity-100'
                : 'pointer-events-none -translate-y-2 scale-95 opacity-0'
            }`}
          >
            <Link
              href='/user'
              className='block px-2 py-1 text-sm hover:bg-gray-100'
            >
              My Account
            </Link>
            <button
              className='block w-full px-2 py-1 text-left hover:bg-gray-100'
              onClick={() => toast.success('Logout successful')}
            >
              <Logout />
            </button>
          </div>
        </div>
      ) : (
        <div
          onClick={() => setIsSignInOpen(true)}
          className='mx-1 cursor-pointer whitespace-nowrap rounded-md border-2 border-[#1D1D1F] px-4 py-1.5 text-sm font-medium'
        >
          Sign In
        </div>
      )}
    </>
  );
};

export default SignButton;
